import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import {
    jsBridgeForSSAI,
    isSSAI,
    destroyDraftToolsBar
} from './utils';
import './style.scss';
import DataGovernance from './DataGovernance';
var SpadBack = function () {
    function SpadBack(options, callback) {
        _classCallCheck(this, SpadBack);
        this.options = options;
        this.fn = callback;
        this.normBackUrlStr = '';
        this.backUrlArr = [];
        this.backUrlArr2 = [];
        this.qmQuitAudioUrl = '';
        this.pressSysBackCallback = null;
        if (isSSAI()) {
            jsBridgeForSSAI('getBackData', { key: 'backUrlArr' }, 'getUrlBack');
            jsBridgeForSSAI('setTitle', { 'title': '' });
        }
        this.init();
    }
    _createClass(SpadBack, [
        {
            key: 'songShuPrintBack',
            value: function songShuPrintBack() {
                window.closePreviewReport();
                var app = document.getElementById('app');
                if (app) {
                    app.style.display = 'block';
                }
            }
        },
        {
            key: 'init',
            value: function init() {
                var _this = this;
                this.watchUrl();
                if (!window.dataGovernance) {
                    setTimeout(function () {
                        var dataGovernanceParams = {};
                        window.dataGovernance = new DataGovernance(dataGovernanceParams);
                        window.dataGovernance.sendData();
                    }, 5000);
                }
                window.getUrlBack = function (res) {
                    if (res != 'null') {
                        var resObj = JSON.parse(res);
                        if (resObj.length > 0) {
                            _this.backUrlArr = resObj;
                        }
                    }
                };
                window.onPressSysKey = function (type) {
                    window.onPressSysKey4Monitor && window.onPressSysKey4Monitor(type);
                    if (type == 'back') {
                        _this.pressSysBackCallback && _this.pressSysBackCallback();
                        var pathName = window.location.pathname;
                        var link = window.location.href;
                        var previewReoprtDialog = document.getElementById('previewReoprtDialog');
                        if (link.indexOf('exam-test.classba.cn') > -1 || link.indexOf('exam-pre.classba.cn') > -1 || link.indexOf('exam.classba.cn') > -1) {
                            var _JSON$parse = JSON.parse(localStorage.getItem('UserInfo')), status = _JSON$parse.status;
                            if (status == 3) {
                                if (pathName.indexOf('mock/result') > -1) {
                                    _this.backCourse();
                                } else {
                                    history.back();
                                }
                            } else {
                                _this.backCourse();
                            }
                            return;
                        }
                        console.log(previewReoprtDialog, 'previewReoprtDialog');
                        if (previewReoprtDialog && previewReoprtDialog.style.display != 'none') {
                            _this.songShuPrintBack();
                            return;
                        }
                        if (pathName.indexOf('/question') > -1 || pathName.indexOf('/setsquestions') > -1 || pathName.indexOf('/composition') > -1 && pathName.indexOf('/compositionreport') === -1 || pathName.indexOf('/modulecn/ch/study') > -1 || pathName.indexOf('/followQuestion') > -1 || pathName.indexOf('/modulecn/ch/subject') > -1 || sessionStorage.getItem('isUnify')) {
                            if (!document.getElementById('insistQuitting')) {
                                if (sessionStorage.getItem('isUnify')) {
                                    _this.showAiReviewConfirmDialog();
                                } else {
                                    _this.showConfirmDialog();
                                }
                                window.CalcStepHook && window.CalcStepHook.disappear();
                                if (window.HWRecognizer && window.HWRecognizer.checkShow()) {
                                    window.HWRecognizer.hide();
                                }
                            }
                        } else {
                            var isReportCenter = sessionStorage.getItem('isReportCenter');
                            console.warn(isReportCenter, 'isReportCenter');
                            if (isReportCenter) {
                                var currentReportUrl = sessionStorage.getItem('currentReportUrl');
                                if (currentReportUrl === location.href || location.href.indexOf(currentReportUrl) > -1) {
                                    _this.backCourse();
                                    return;
                                }
                                console.warn('向后返回');
                                history.back();
                                return;
                            }
                            if (_this.isYingShuWuDemo()) {
                                history.back();
                                return;
                            }
                            _this.backCourse();
                        }
                    }
                };
            }
        },
        {
            key: 'watchUrl',
            value: function watchUrl() {
                var url = location.href;
                var _pushState = window.history.pushState;
                console.warn(url, 'watchUrl');
                window.history.pushState = function (event) {
                    var currentReportUrl = sessionStorage.getItem('currentReportUrl');
                    console.warn(url, '当前地址');
                    console.warn(event, '当前地址event');
                    if (!currentReportUrl) {
                        url = arguments[2];
                        console.warn('将要跳转的url' + url);
                        if (url.indexOf('report') > -1 && url.indexOf('68') > -1) {
                            sessionStorage.setItem('currentReportUrl', url);
                            sessionStorage.setItem('isReportCenter', 1);
                            console.warn('设置当前url' + url);
                        }
                    } else {
                        if (url.indexOf('report') > -1 && url.indexOf('68') > -1 && url.indexOf('/en2/')) {
                            sessionStorage.setItem('currentReportUrl', url);
                            sessionStorage.setItem('isReportCenter', 1);
                            console.warn('en2重新设置当前url' + url);
                        }
                    }
                    return _pushState.apply(this, arguments);
                };
                this.newCnReportBack(url);
            }
        },
        {
            key: 'newCnReportBack',
            value: function newCnReportBack(url) {
                var currentReportUrl = sessionStorage.getItem('currentReportUrl');
                if (currentReportUrl && currentReportUrl === location.href) {
                    return;
                }
                if (url.indexOf('report') > -1 && url.indexOf('68') > -1 && url.indexOf('newcn')) {
                    sessionStorage.setItem('currentReportUrl', url);
                    sessionStorage.setItem('isReportCenter', 1);
                    console.warn('newcn重新设置当前url' + url);
                }
            }
        },
        {
            key: 'isYingShuWuDemo',
            value: function isYingShuWuDemo() {
                var isDemo = false;
                if ((location.href.indexOf('demo.test.classba.cn') > -1 || location.href.indexOf('demo-pre.classba.cn') > -1 || location.href.indexOf('demo.classba.cn') > -1) && location.href.indexOf('report/detail') > -1) {
                    isDemo = true;
                }
                return isDemo;
            }
        },
        {
            key: 'reportDetailBack',
            value: function reportDetailBack() {
                var isReportCenter = sessionStorage.getItem('isReportCenter');
                if (isReportCenter) {
                    history.back();
                }
            }
        },
        {
            key: 'backCourse',
            value: function backCourse() {
                console.warn('返回课程中心');
                sessionStorage.removeItem('currentReportUrl');
                destroyDraftToolsBar();
                jsBridgeForSSAI('hideAiRobot');
                sessionStorage.removeItem('url_subject_id');
                sessionStorage.removeItem('url_api_demo');
                if (this.backUrlArr.length > 0) {
                    window.location.href = this.backUrlArr[0];
                } else {
                    jsBridgeForSSAI('closePage');
                }
            }
        },
        {
            key: 'showConfirmDialog',
            value: function showConfirmDialog() {
                var _this2 = this;
                var tipsText = '正在学习中\uFF0C确认退出\uFF1F';
                var pop = document.createElement('div');
                var popMask = document.createElement('div');
                pop.id = 'spad-back-page-fixed';
                pop.classList = 'spad-back-page-fixed';
                popMask.classList = 'back-mask';
                var html = '<div class="spad-back-content"><p class="tips">'.concat(tipsText, '</p><div class="bottom-btns"><a class="btn quit" id="insistQuitting">坚持退出</a><a class="btn keep-answer" id="keepAnswering">继续作答</a></div></div>');
                pop.innerHTML = html;
                document.body.appendChild(pop);
                document.body.appendChild(popMask);
                if (document.getElementById('insistQuitting')) {
                    document.getElementById('insistQuitting').onclick = function (e) {
                        window.CalcStepHook && window.CalcStepHook.hide();
                        _this2.insistQuitting();
                        _this2.qmQuitAudioUrl && _this2.playAudioNative(_this2.qmQuitAudioUrl, 2);
                        e.stopPropagation();
                    };
                }
                if (document.getElementById('keepAnswering')) {
                    document.getElementById('keepAnswering').onclick = function (e) {
                        window.CalcStepHook && window.CalcStepHook.appear();
                        _this2.keepAnswering();
                        _this2.qmQuitAudioUrl && _this2.playAudioNative(_this2.qmQuitAudioUrl, 2);
                        e.stopPropagation();
                    };
                }
                if (sessionStorage.getItem('normalized_app_name') == 'qimeng') {
                    if (!this.qmQuitAudioUrl) {
                        var hostname = window.location.hostname;
                        var env = 'prod';
                        if (hostname.indexOf('-test') > -1) {
                            env = 'test';
                        } else if (hostname.indexOf('-pre') > -1) {
                            env = 'pre';
                        } else if (hostname.indexOf('fe.dev') > -1) {
                            env = 'dev';
                        }
                        this.qmQuitAudioUrl = 'https://statics.classba.cn/'.concat(env, '/fe_public/public/audio/isQuit.MP3');
                    }
                    this.playAudioNative(this.qmQuitAudioUrl);
                }
            }
        },
        {
            key: 'playAudioNative',
            value: function playAudioNative(audioUrl) {
                var audioType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                if (isSSAI()) {
                    jsBridgeForSSAI('playAudio', {
                        audioUrl: audioUrl,
                        audioType: audioType
                    });
                }
            }
        },
        {
            key: 'showAiReviewConfirmDialog',
            value: function showAiReviewConfirmDialog() {
                var _this3 = this;
                var isForce = sessionStorage.getItem('isUnify') == '2';
                var tipsText = '确定退出本次复习吗\uFF1F';
                var pop = document.createElement('div');
                var popMask = document.createElement('div');
                pop.id = 'spad-back-page-fixed';
                pop.classList = 'spad-back-page-fixed';
                popMask.classList = 'back-mask';
                var html = '<div class="spad-back-content-aireview '.concat(isForce ? 'force' : '', '"><p class="tips">').concat(tipsText, '</p><p class="tips-else">坚持一下\uFF0C很快就要完成复习啦~</p><div class="bottom-btns"><a class="btn quit" id="insistQuitting">暂时离开</a><a class="btn keep-answer" id="keepAnswering">继续复习</a></div>').concat(isForce ? '' : '<div class="tips-wrap"><span>清空当前已完成的记录\uFF0C</span><a class="giveup-btn" id="giveUpInsistQuitting">放弃复习</a></div>', '</div>');
                pop.innerHTML = html;
                document.body.appendChild(pop);
                document.body.appendChild(popMask);
                if (document.getElementById('insistQuitting')) {
                    document.getElementById('insistQuitting').onclick = function (e) {
                        window.CalcStepHook && window.CalcStepHook.hide();
                        _this3.insistQuitting();
                        e.stopPropagation();
                    };
                }
                if (document.getElementById('keepAnswering')) {
                    document.getElementById('keepAnswering').onclick = function (e) {
                        window.CalcStepHook && window.CalcStepHook.appear();
                        _this3.keepAnswering();
                        e.stopPropagation();
                    };
                }
                if (document.getElementById('giveUpInsistQuitting')) {
                    document.getElementById('giveUpInsistQuitting').onclick = function (e) {
                        window.giveUpAiReview(function () {
                            console.log('spadback 放弃成功');
                            window.CalcStepHook && window.CalcStepHook.hide();
                            _this3.insistQuitting();
                            e.stopPropagation();
                        });
                    };
                }
            }
        },
        {
            key: 'insistQuitting',
            value: function insistQuitting() {
                this.backCourse();
            }
        },
        {
            key: 'keepAnswering',
            value: function keepAnswering() {
                document.getElementsByClassName('spad-back-page-fixed')[0].remove();
                document.getElementsByClassName('back-mask')[0].remove();
            }
        },
        {
            key: 'addBackUrl',
            value: function addBackUrl(url) {
                if (this.backUrlArr2.indexOf(url) == -1) {
                    this.backUrlArr2.push(url);
                }
            }
        },
        {
            key: 'normFinish',
            value: function normFinish() {
                if (this.normBackUrlStr) {
                    window.location.href = this.normBackUrlStr;
                } else {
                    jsBridgeForSSAI('closePage');
                }
            }
        }
    ]);
    return SpadBack;
}();
export default SpadBack;